import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	legalConsentHeading: {
		id: 'fastshift.legal-consent-page.heading',
		defaultMessage: 'Start using FastShift Portal',
		description:
			'Heading for landing page shown to customers when they use Fastshift Portal for the first time.',
	},
	legalConsentDescription: {
		id: 'fastshift.legal-consent-page.description',
		defaultMessage:
			'The FastShift Portal enables visibility and collaboration across teams working on your migration, including Atlassian, your partners, and your own teams. Use of the FastShift Portal is governed by the <a>Atlassian Customer Agreement</a> and <b>Atlassian Privacy Policy</b>.*',
		description:
			'Usage agreement details for the consent landing page shown to customers when they use Fastshift Portal for the first time.',
	},
	legalConsentFeatureHeadlineText: {
		id: 'fastshift.legal-consent-page.description-headline',
		defaultMessage: 'FastShift Portal allows you and your migration team to:',
		description:
			'This text is shown directly above a table describing some features of fastshift portal.',
	},
	legalConsentPortalFeature_TrackTickets_Heading: {
		id: 'fastshift.legal-consent-page.feature.track-tickets.heading',
		defaultMessage: 'Track tickets',
		description:
			'Heading for Fastshift Portal Feature Tile - feature: lets you track migration support tickets.',
	},
	legalConsentPortalFeature_TrackTickets_Description: {
		id: 'fastshift.legal-consent-page.feature.track-tickets.description',
		defaultMessage: 'View all migration tickets in one place.',
		description:
			'Description for Fastshift Portal Feature Tile - feature: lets you track migration support tickets.',
	},
	legalConsentPortalFeature_PlanMigration_Heading: {
		id: 'fastshift.legal-consent-page.feature.plan-migration.heading',
		defaultMessage: 'Plan migration',
		description:
			'Heading for Fastshift Portal Feature Tile - feature: helps you plan your migration.',
	},
	legalConsentPortalFeature_PlanMigration_Description: {
		id: 'fastshift.legal-consent-page.feature.plan-migration.description',
		defaultMessage: 'Have an overview of nexts steps of your migration.',
		description:
			'Description for Fastshift Portal Feature Tile - feature: helps you plan your migration.',
	},
	legalConsentPortalFeature_ViewResources_Heading: {
		id: 'fastshift.legal-consent-page.feature.view-resources.heading',
		defaultMessage: 'View resources',
		description:
			'Heading for Fastshift Portal Feature Tile - feature: helps you share and review documents.',
	},
	legalConsentPortalFeature_ViewResources_Description: {
		id: 'fastshift.legal-consent-page.feature.view-resources.description',
		defaultMessage: 'Get dedicated resources focused on each phase of your migration.',
		description:
			'Description for Fastshift Portal Feature Tile - feature: helps you share and review documents.',
	},
	legalConsentPortalFeature_LegalAgreementCheckboxText: {
		id: 'fastshift.legal-consent-page.legal-agreement-checkbox-text',
		defaultMessage:
			'I understand that the FastShift Portal is a “Free or Beta Product” under Section 17 of the Atlassian Customer Agreement and I authorize its use by the teams supporting my migration.',
		description:
			'Description for Fastshift Portal legal agreement. This text is shown next to a checkbox, and the user ticks the checkbox if they agree with this statement. This is important to translate accurately.',
	},
	legalConsentPortalFeature_LegalAgreementFooter: {
		id: 'fastshift.legal-consent-page.legal-agreement-footer',
		defaultMessage: '*If you have any questions, please contact your delivery manager.',
		description:
			'Footer underneath the main text to describe how the customer can seek assistance in further understanding the context of the legal consent page.',
	},
	legalConsentPortalFeature_ProceedToPortalButton: {
		id: 'fastshift.legal-consent-page.button.proceed-to-portal',
		defaultMessage: 'Proceed to FastShift Portal',
		description:
			'Clicking this button lets you access the rest of Fastshift Portal. (This button is only enabled if the user has ticked the user agreement checkbox to indicate their consent.)',
	},
	legalConsentPortalFeature_ProceedToPortalButtonAriaLabelWhenDisabled: {
		id: 'fastshift.legal-consent-page.button.proceed-to-portal.aria-label.when-disabled',
		defaultMessage:
			'Proceed to FastShift Portal. To enable this button, select the consent check box above.',
		description: 'Aria label for the proceed to portal button when it is disabled.',
	},
	legalConsentPortalFeature_SuccessFlag_Title: {
		id: 'fastshift.legal-consent-page.success-flag.title',
		defaultMessage: 'We’ve saved your consent',
		description: 'Title of success flag shown when the user consents successfully.',
	},
	legalConsentPortalFeature_SuccessFlag_Description: {
		id: 'fastshift.legal-consent-page.success-flag.description',
		defaultMessage: 'Your consent has been successfully recorded.',
		description: 'Description of success flag shown when the user consents successfully.',
	},
	legalConsentPortalFeature_ErrorFlag_Title: {
		id: 'fastshift.legal-consent-page.error-flag.title',
		defaultMessage: 'We’re unable to save your consent right now',
		description:
			'Title of error flag shown when the user submits consent but there is some backend error causing it to fail.',
	},
	legalConsentPortalFeature_ErrorFlag_Description: {
		id: 'fastshift.legal-consent-page.error-flag.description',
		defaultMessage: 'Refresh the page or try again later.',
		description:
			'Description of error flag shown when the user submits consent but there is some backend error causing it to fail.',
	},
});
